<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-crear-viaje"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form-crear-viaje-label"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white pt-2 pb-2">
            <h4 class="modal-title text-white" id="modal-form-crear-viaje-label">
              <i class="fas fa-route mr-2"></i>
              Crear Viaje
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
              @click="limpiarModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="cargando" class="text-center py-3">
              <i class="fas fa-spinner fa-spin fa-2x"></i>
              <p class="mt-2">Cargando información...</p>
            </div>
            <div v-else>
              <div class="form-group">
                <label for="id-registro" class="font-weight-bold">
                  ID del Registro:
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="id-registro"
                  :value="id"
                  readonly
                />
              </div>
              
              <div class="form-group mt-3">
                <div class="btn-group w-100" role="group">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="clickSitio"
                  >
                    <i class="fas fa-building mr-2"></i>
                    Sitio
                  </button>
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="clickPuntoGestion"
                  >
                    <i class="fas fa-map-marker-alt mr-2"></i>
                    Punto Gestión
                  </button>
                </div>
              </div>

              <div v-if="mostrarSitios && rutas && rutas.sitios" class="form-group mt-3">
                <label class="font-weight-bold">Seleccionar Sitio:</label>
                <v-select
                  v-model="sitioSeleccionado"
                  :options="rutas.sitios"
                  label="nombre"
                  placeholder="Seleccione un sitio..."
                  disabled
                ></v-select>
              </div>

              <div v-if="mostrarPuntosGestion && rutas && rutas.puntos_gestion" class="form-group mt-3">
                <label class="font-weight-bold">Seleccionar Punto Gestión:</label>
                <v-select
                  v-model="puntoGestionSeleccionado"
                  :options="rutas.puntos_gestion"
                  label="nombre"
                  placeholder="Seleccione un punto gestión..."
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="limpiarModal"
            >
              Cerrar
            </button>
            <button
              v-if="(sitioSeleccionado && mostrarSitios) || (puntoGestionSeleccionado && mostrarPuntosGestion)"
              type="button"
              class="btn btn-primary"
              @click="crearViaje"
              :disabled="guardando"
            >
              <i class="fas fa-route mr-2"></i>
              <span v-if="guardando">Creando...</span>
              <span v-else>Crear Viaje</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import $  from "jquery";

export default {
  name: "GestionHidrocarburosCrearViaje",
  components: {
    vSelect,
  },
  data() {
    return {
      id: null,
      sitio_id: null,
      sitio_destino_id: null,
      rutas: null,
      cargando: false,
      guardando: false,
      mostrarSitios: false,
      mostrarPuntosGestion: false,
      sitioSeleccionado: null,
      puntoGestionSeleccionado: null,
    };
  },
  methods: {
    clickSitio() {
      this.mostrarSitios = !this.mostrarSitios;
      this.mostrarPuntosGestion = false;
      this.puntoGestionSeleccionado = null;
    },
    clickPuntoGestion() {
      this.mostrarPuntosGestion = !this.mostrarPuntosGestion;
      this.mostrarSitios = false;
      //this.sitioSeleccionado = null;
    },
    llenarModal(id, sitio_id, sitio_destino_id) {
      this.id = id;
      this.sitio_id = sitio_id;
      this.sitio_destino_id = sitio_destino_id;
      this.cargando = true;
      this.rutas = null;
      
      axios
        .get("/api/admin/centralTrafico/rutas", {
          params: {
            sitio_id: sitio_id,
            sitio_destino_id: sitio_destino_id,
          },
        })
        .then((response) => {
          this.rutas = response.data;
          // Seleccionar por defecto el sitio cuyo id coincida con sitio_id
          if (this.rutas && Array.isArray(this.rutas.sitios)) {
            this.sitioSeleccionado = this.rutas.sitios.find(
              (s) => s.id == this.sitio_id
            ) || null;
          }
          this.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text:
              "Error al cargar la información: " +
              (error.response?.data?.message || error.message),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    limpiarModal() {
      this.id = null;
      this.sitio_id = null;
      this.sitio_destino_id = null;
      this.rutas = null;
      this.cargando = false;
      this.guardando = false;
      this.mostrarSitios = false;
      this.mostrarPuntosGestion = false;
      this.sitioSeleccionado = null;
      this.puntoGestionSeleccionado = null;
    },
    crearViaje() {
      if (!this.sitioSeleccionado && !this.puntoGestionSeleccionado) {
        this.$swal({
          icon: "warning",
          title: "Advertencia",
          text: "Por favor seleccione un sitio o punto de gestión",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.guardando = true;

      let datos = {
        det_postulacion_id: this.id,
      };

      if (this.puntoGestionSeleccionado) {
        datos.sitio_type = "App\\PuntoGestion";
        datos.sitio_id = this.puntoGestionSeleccionado.id;
      } else if (this.sitioSeleccionado) {
        datos.sitio_type = "App\\Sitio";
        datos.sitio_id = this.sitio_id;
      } 

      axios
        .post("/api/admin/centralTrafico/crearViaje", datos)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El viaje se ha creado correctamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.guardando = false;
          this.limpiarModal();
          this.$refs.closeModal.click();
          this.$parent.cargarDatos();
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text:
              "Error al crear el viaje: " +
              (error.response?.data?.message || error.message),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.guardando = false;
        });
    },
  },
};
</script>

